export const selectFilter = store => store.filter.filter;
export const selectBrand = store => store.filter.brand;
